import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import NavigationActionCreator from 'action_creators/navigation';
import FormControllerProxy from 'lib/form/controller_proxy';
import Addons from 'views/plugins/booking_request/addons';
import { t } from 'services/translation';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';

const BookingAddonsScreen = createReactClass({
  displayName: 'BookingAddonsScreen',

  propTypes: {
    addons: PropTypes.array.isRequired,
    addonAvailability: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    fields: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    guests: PropTypes.number,
    priceProps: PropTypes.object,
    showPersonalSection: PropTypes.bool,
    skipPayment: PropTypes.bool,
    shouldShowAdditionalInformation: PropTypes.bool,
    fromSummary: PropTypes.bool,
    isMobileFirstEnabled: PropTypes.bool,
  },

  mixins: [PureRenderMixin, FormControllerProxy],

  componentDidMount() {
    // Trigger scroll to iframe for mobile booking flow
    triggerCheckoutStepScroll();
  },

  componentDidUpdate(prevProps, prevState) {
    const {
      fromSummary,
      showPersonalSection,
      skipPayment,
      shouldShowAdditionalInformation,
      shouldCollectGuestInfo,
      isMobileFirstEnabled,
    } = this.props;
    const directToSummary = !showPersonalSection && skipPayment;
    let nextScreen, nextScreenPath;

    if (this._hasSaved(prevProps)) {
      if (isMobileFirstEnabled) {
        nextScreenPath = `Views.Plugins.Checkout.MobileFirst`;
      } else {
        if (fromSummary && shouldCollectGuestInfo) {
          nextScreen = 'GuestInformation';
        } else if (fromSummary || directToSummary) {
          if (shouldShowAdditionalInformation) {
            nextScreen = 'AdditionalInformation';
          } else {
            nextScreen = 'CheckoutSummary';
          }
        } else if (!showPersonalSection) {
          nextScreen = 'CheckoutPayment';
        } else {
          nextScreen = 'CheckoutPersonal';
        }
        nextScreenPath = `Views.Plugins.Checkout.Mobile.Screens.${nextScreen}`;
      }

      NavigationActionCreator.transitionTo(nextScreenPath, {
        fromSummary: fromSummary,
      });
    }
  },

  _hasSaved(prevProps) {
    return this.props.saved === true && prevProps.saved === false;
  },

  _addonsProps() {
    return {
      availableAddons: this.props.addons,
      guests: this.props.guests,
      addonAvailability: this.props.addonAvailability,
      date: this.props.date,
      time: this.props.time,
      tourTimezone: this.props.tour_timezone,
    };
  },

  _coverProps() {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  },

  render() {
    let submitLabel;
    if (this.props.fields.get('addons').length === 0) {
      submitLabel = t('NO_THANKS');
    } else {
      submitLabel = t(
        `${this.props.tour.settings.continue_booking_label.value}`
      );
    }

    return (
      <div className="BookingAddonsScreen">
        <CheckoutHeader priceProps={this.props.priceProps} />

        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          <div className="BookingRequest-form ui form">
            <Addons {...this._formProps('addons', this._addonsProps())} />
            <Submit
              dataTestProp="mobile-addons-submit"
              label={submitLabel}
              onSubmit={this.props.onSubmit}
            />
          </div>
        </article>
      </div>
    );
  },
});

export default BookingAddonsScreen;
